<script lang="ts">
  let { title, round = false }: { title?: string; round?: boolean } = $props();
</script>

<button class:round on:click|preventDefault {title}><slot /></button>

<style>
  button {
    color: var(--color-text-primary);
    border: none;
    background: rgba(255, 255, 255, 0.2);
    width: 100%;
    margin: 6px;
    transition: box-shadow 100ms ease-out;
  }
  button:hover {
    color: var(--color-text-primary);
    background: rgba(255, 255, 255, 0.3);
    box-shadow: 0 0 2px 1px #0003;
  }
  button:focus {
    box-shadow: 0 0 0 2px #0003;
  }
  button:active {
    box-shadow: inset 0 0 0 1px #0004;
  }
  .round {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 15px;
    height: 30px;
    padding: 0 16px 0 8px;
  }
  .round:hover {
    background: rgba(255, 255, 255, 0.3);
  }
</style>
